import { fixtureMatchHidden } from '../config/featureHides';
import React, { useEffect } from 'react'

import { ProtectedRouter, ProtectedRouterTwo, RootRedirect } from "./ProtectedRouter";
import { BrowserRouter, Outlet, Route, Routes, Navigate } from "react-router-dom";
import FeatureGate from "./FeatureGate";
import ShellOnNav from "../nav/ShellOnNav";
import EntitlementGuard from "./EntitlementGuard";
import NavV6Gate from "../nav/NavV6Gate";
import { themesOpen } from "../nav/navModel";

import VerifyEmailProcess from "../pages/Auth/VerifyEmail/VerifyEmailProcess";
import ForgetPassword from "../pages/Auth/ResetPassword/ForgetPassword";
import ResetPassword from "../pages/Auth/ResetPassword/ResetPassword";
import LogoutProcess from "../pages/Auth/Logout/LogoutProcess";
import VerifyEmail from "../pages/Auth/VerifyEmail/VerifyEmail";
import Dashboard from "../pages/Board/Dashboard";
import Signup from "../pages/Auth/Signup";
import Login from "../pages/Auth/Login";

import CampaignDatatable from "../pages/Campaign/DataTable";
import CreateCampaign from "../pages/Campaign/Components/Create";
import UpdateCampaign from "../pages/Campaign/Components/Update";
import CampaignSetup from "../pages/Campaign/Components/setup/CampaignSetup";
// 2026 rebuild — same hooks/dialogs, redesigned UI.
import ShowsGallery from "../pages/Campaign/ShowsGallery";

import DeviceShow from "../pages/Devices/Component/Show";
import { RedirectHealthFleet, RedirectHealthScreen } from "../pages/Devices/Component/Health/Redirects";
import Index from "../pages/Devices/Index";

import PlaylistDatatable from "../pages/Playlist/Datatable";
import PlaylistSetup from "../pages/Playlist/Components/setup/PlaylistSetup";
import PlaylistGallery from "../pages/Playlist/PlaylistGallery";

import FolderDragDrop from "../pages/Media/components/FolderDragDrop/FolderDragDrop";
import MediaDataTable from "../pages/Media";
// New 2026 rebuild — replaces MediaDataTable as the /media/gallery surface.
// Legacy index.jsx + MediaCard/FolderCard remain in the bundle for any
// remaining callers (e.g. interactive campaign setup re-uses MediaCard).
import MediaGallery from "../pages/Media/MediaGallery";
import LinksDataTable from "../pages/Links/DataTable";
import LinksGallery from "../pages/Links/LinksGallery";

import Apps from "../pages/Apps/Apps";

import InteractiveCampaignDatatable from "../pages/Campaign/InteractiveCampaign/DataTable";
import InteractiveCampaignSetup from "../pages/Campaign/InteractiveCampaign/Components/setup/InteractiveCampaignSetup";

import NotFound from "../pages/Layout/NotFound";
import Profile from "../pages/Profile/Profile";
import Reports from "../pages/Reports/Reports";

import axiosInstance from '../config/Axios';

import { CompanyDetailsRouter } from './CompanyDetailsRouter';
import { hasVerifiedSession } from "../utils/authSession";

import CustomRssIndex from '../pages/Apps/CustomRss/CustomRssIndex';
import EmployeeSignUp from '../pages/Auth/EmployeeSignup';
import BroadcastCard from '../pages/Apps/Broadcast/BroadcastCard';
import UsersIndex from '../pages/Users/UsersIndex';
import PrayerCard from '../pages/Apps/Prayer/PrayerCard';
import RssIndex from '../pages/Apps/Rss/RssIndex';
import Multi3DViewerIndex from '../pages/Apps/Multi3dViewer/Multi3DViewerIndex';
import LayoutsIndex from '../pages/Apps/Layouts/LayoutsIndex';
import LayoutSetup from '../pages/Apps/Layouts/components/LayoutSetup';

import { useSelector, useDispatch } from 'react-redux';
import { setPackages } from '../redux/Slices/Global/globalSlice';

import Weather from '../pages/ForDevice/Weather/Weather';
import CornerWeather from '../pages/ForDevice/Weather/CornerWeather';

import WeatherIndex from '../pages/Apps/Weather/WeatherIndex';
import ClockIndex from '../pages/Apps/Clock/ClockIndex';
import Clock from '../pages/ForDevice/Clock/Clock';
import IframePlayer from '../pages/ForDevice/IframePlayer';
// QR Loyalty & Ordering — public guest check-in page (no auth, no admin chrome).
import CustomerCard from '../pages/Guest/CustomerCard';
import ScanStay from '../pages/Guest/ScanStay';
import KitchenDisplay from '../pages/Kitchen/KitchenDisplay';
import CashierDisplay from '../pages/Cashier/CashierDisplay';
import CornerClock from '../pages/ForDevice/Clock/CornerClock';
import AnimatedLayoutIndex from '../pages/Apps/AnimatedLayouts/AnimatedLayoutIndex';
import MatchSchedulerIndex from '../pages/Apps/MatchScheduler/MatchSchedulerIndex';
import AdMarketplaceIndex from '../pages/Apps/AdMarketplace/AdMarketplaceIndex';
import SmartAdSchedulerIndex from '../pages/Apps/SmartAdScheduler/SmartAdSchedulerIndex';
import AdsSettings from '../pages/Billing/AdsSettings';
import AdEarnings  from '../pages/Billing/AdEarnings';

// Hardware Control (Feature: Hardware UI)
// Device / Receiver / Screen SETUP is admin-only (admin panel → company
// "Hardware Setup" tab). Tenants only manage Scenes (user-friendly presets)
// and drive everything from Remote Control.
import ScenesPage    from '../pages/Hardware/ScenesPage';

// Remote Control — hero page, top-level
import RemoteControl from '../pages/RemoteControl/RemoteControl';

// Café Wizard — "+ Create" template picker (café/standard accounts only).
import CafeCreate from '../pages/Cafe/CafeCreate';

// New Show Page — DEV ONLY, coexists with the classic builder (CampaignSetup),
// does not replace it. See .claude/show-slots-prototype.html for the spec.
import ShowPage from '../pages/Shows/ShowPage';

// Aggregator landing pages added with the sidebar restructure — chip-bar
// driven sub-navigation lives in Layout/SectionChipBar.
import ContentHome  from '../pages/Content/ContentHome';
import CustomersIndex from '../pages/Customers/CustomersIndex';
import CustomerProfile from '../pages/Customers/CustomerProfile';
import AutomationFeed from '../pages/Automation/AutomationFeed';
import CampaignsIndex from '../pages/Marketing/CampaignsIndex';
// QR Loyalty & Ordering — owner dashboard (Phase 2). Feature-gated pages.
import LoyaltySettings from '../pages/Loyalty/LoyaltySettings';
import LoyaltyRewards from '../pages/Loyalty/LoyaltyRewards';
import LoyaltyFeatured from '../pages/Loyalty/LoyaltyFeatured';
import LoyaltyAnalytics from '../pages/Loyalty/LoyaltyAnalytics';
import ScheduleHome from '../pages/Schedule/ScheduleHome';
import MoneyHome    from '../pages/Money/MoneyHome';
import BirthdayMode from '../pages/Apps/Birthday/BirthdayMode';
import HappyHour    from '../pages/Apps/HappyHour/HappyHour';
import Promos       from '../pages/Apps/Promos/Promos';
import SpinWin      from '../pages/Apps/SpinWin/SpinWin';
import VideoWallIndex        from '../pages/Apps/VideoWall/Index';
import VideoWallDashboard    from '../pages/Apps/VideoWall/Dashboard';
import VideoWallCreate       from '../pages/Apps/VideoWall/Create';
import VideoWallLibrary      from '../pages/Apps/VideoWall/Library';
import VideoWallLibraryEditor from '../pages/Apps/VideoWall/LibraryEditor';
import VideoWallGroups       from '../pages/Apps/VideoWall/Groups';
import VideoWallGroupShow    from '../pages/Apps/VideoWall/GroupShow';
import VideoWallLocations    from '../pages/Apps/VideoWall/Locations';
import VideoWallSchedule     from '../pages/Apps/VideoWall/Schedule';
import ScheduleThemesRoute  from '../pages/Schedule/v6/ScheduleThemesRoute';
import CafeLocations         from '../pages/Locations/CafeLocations';
import VideoWallMenus        from '../pages/Apps/VideoWall/Menus';
import VideoWallMenuEditor   from '../pages/Apps/VideoWall/MenuEditor';
import VideoWallMenuBuilder  from '../pages/Apps/VideoWall/MenuBuilder';
import VideoWallTemplates    from '../pages/Apps/VideoWall/Templates';
import VideoWallTemplateEditor from '../pages/Apps/VideoWall/TemplateEditor';
import VideoWallSimulator    from '../pages/Apps/VideoWall/Simulator';
import VideoWallPromos       from '../pages/Apps/VideoWall/Promos';
import VideoWallShow         from '../pages/Apps/VideoWall/Show';

// Unknown URLs: a signed-in user goes through the same plan gate as every page (so a
// company with no active package sees the no-package state, and the shell's data is
// loaded); a signed-out visitor sees the plain 404.
const NotFoundGate = () => (hasVerifiedSession() ? <CompanyDetailsRouter /> : <Outlet />);

function RoutesContainer() {
    const companyDetails = useSelector((state) => state.global.companyDetails);
    const dispatch = useDispatch();

    const features = companyDetails?.package?.features;

    useEffect(() => {
        axiosInstance
            .get(`/landing/packages`)
            .then((result) => {
                dispatch(setPackages(result?.data?.data));
            })
            .catch(() => {
                // Handled globally by axios interceptors (redirect/toast)
            });
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<RootRedirect />} />
                <Route element={<ProtectedRouter />}>
                    <Route element={<CompanyDetailsRouter />}>
                        <Route path="/dashboard" element={<Dashboard />} />

                        <Route group="media">
                            <Route path="/media/gallery/:id?" element={<MediaGallery />} />
                            <Route path="/media/move" element={<FolderDragDrop />} />
                            <Route path="/links" element={<LinksGallery />} />
                        </Route>

                        <Route path="/profile" element={<Profile />} />
                        <Route path="/reports" element={<Reports />} />

                        <Route group="users">
                            <Route path="/users" element={<UsersIndex />} />
                        </Route>

                        {
                            features?.interactive_action &&
                            <Route group="/interactive/campaigns">
                                <Route path="/interactive/campaigns" element={<InteractiveCampaignDatatable />} />
                                <Route path="/interactive/campaign/:id/setup" element={<InteractiveCampaignSetup />} />
                            </Route>
                        }

                        <Route group="campaigns">
                            <Route path="/campaigns/list" element={<ShowsGallery />} />
                            <Route path="/campaigns/:type?/:id/setup" element={<CampaignSetup />} />

                            <Route path="/campaigns/create" element={<CreateCampaign />} />
                            <Route path="/campaigns/:id/update" element={<UpdateCampaign />} />
                        </Route>

                        <Route group="devices">
                            <Route path="/devices/list" element={<Index />} />
                            <Route path="/devices/:id/show" element={<DeviceShow />} />
                            <Route path="/devices/health" element={<RedirectHealthFleet />} />
                            <Route path="/devices/:id/health" element={<RedirectHealthScreen />} />
                        </Route>

                        <Route group="playlist">
                            <Route path="/playlist/list" element={<PlaylistGallery />} />
                            <Route path="/playlist/:id/show" element={<PlaylistSetup />} />
                        </Route>

                        <Route group="apps">
                            <Route path="/apps" element={<Apps />} />
                            <Route path="/apps/prayer" element={<FeatureGate feature="prayer_app"><PrayerCard /></FeatureGate>} />

                            <Route path="/apps/broadcast" element={<FeatureGate feature="live_meeting_access"><BroadcastCard /></FeatureGate>} />

                            <Route path="/apps/rss" element={<FeatureGate feature="rss_feed"><RssIndex /></FeatureGate>} />
                            <Route path="/apps/rss/custom" element={<FeatureGate feature="rss_feed"><CustomRssIndex /></FeatureGate>} />


                            <Route path="/apps/3d/viewer" element={<Multi3DViewerIndex />} />

                            <Route path="/apps/layouts" element={<FeatureGate feature="layouts"><LayoutsIndex /></FeatureGate>} />
                            <Route path="/apps/layouts/:id/show" element={<FeatureGate feature="layouts"><LayoutSetup /></FeatureGate>} />

                            <Route path="/apps/animated_layouts" element={<FeatureGate feature="animated_layouts"><AnimatedLayoutIndex /></FeatureGate>} />
                            <Route path="/apps/animated_layouts/:id/show" element={<FeatureGate feature="animated_layouts"><LayoutSetup /></FeatureGate>} />


                            <Route path="/apps/rss" element={<FeatureGate feature="rss_feed"><RssIndex /></FeatureGate>} />
                            <Route path="/apps/rss/custom" element={<FeatureGate feature="rss_feed"><CustomRssIndex /></FeatureGate>} />


                            <Route path="/apps/3d/viewer" element={<Multi3DViewerIndex />} />

                            <Route path="/apps/layouts" element={<FeatureGate feature="layouts"><LayoutsIndex /></FeatureGate>} />
                            <Route path="/apps/layouts/:id/show" element={<FeatureGate feature="layouts"><LayoutSetup /></FeatureGate>} />

                            <Route path="/apps/weather" element={<FeatureGate feature="weather"><WeatherIndex /></FeatureGate>} />

                            <Route path="/apps/clock" element={<FeatureGate feature="clock"><ClockIndex /></FeatureGate>} />

                            {/* Discoverability over gating — the sidebar chip bar
                                points here, so the route must always render.
                                Page-level FeatureLocked panel surfaces the upgrade
                                CTA when the backend 402s the data calls. */}
                            <Route path="/apps/match-scheduler"    element={fixtureMatchHidden() ? <Navigate to="/schedule" replace /> : <FeatureGate feature="match_scheduler"><MatchSchedulerIndex /></FeatureGate>} />
                            <Route path="/apps/ad-marketplace"     element={<FeatureGate feature="ad_marketplace"><AdMarketplaceIndex /></FeatureGate>} />
                            <Route path="/apps/smart-ad-scheduler" element={fixtureMatchHidden() ? <Navigate to="/schedule" replace /> : <FeatureGate feature="smart_ad_scheduler"><SmartAdSchedulerIndex /></FeatureGate>} />

                        </Route>

                        {/* Billing: Ad Settings & Earnings */}
                        <Route path="/billing/ads-settings" element={<EntitlementGuard feature="ad_marketplace"><AdsSettings /></EntitlementGuard>} />
                        <Route path="/billing/ad-earnings"  element={<EntitlementGuard feature="ad_marketplace"><AdEarnings /></EntitlementGuard>} />

                        {/* Hardware: Scenes only (device/receiver/screen setup
                            moved to the admin panel). */}
                        <Route path="/hardware/scenes"    element={<EntitlementGuard feature="hardware_control"><ShellOnNav><ScenesPage /></ShellOnNav></EntitlementGuard>} />

                        {/* Sidebar aggregator landing pages. Sub-navigation
                            lives in Layout/SectionChipBar — clicking a chip
                            navigates to the underlying existing route (Files
                            → /media/gallery etc.) so bookmarks keep working. */}
                        <Route path="/content"  element={<ContentHome />} />
                        <Route path="/schedule" element={<ScheduleHome />} />
                        <Route path="/money"    element={<MoneyHome />} />

                        {/* Smart CRM — Customers directory (feature gate added in Step 6). */}
                        <Route path="/customers" element={<EntitlementGuard feature="crm_customers"><CustomersIndex /></EntitlementGuard>} />
                        <Route path="/customers/:id" element={<EntitlementGuard feature="crm_customers"><CustomerProfile /></EntitlementGuard>} />
                        <Route path="/automation" element={<FeatureGate feature="crm_customers"><AutomationFeed /></FeatureGate>} />

                        {/* Smart CRM — Marketing campaigns (Step 7), gated on marketing_email. */}
                        <Route path="/marketing/campaigns" element={<FeatureGate feature="marketing_email"><CampaignsIndex /></FeatureGate>} />

                        {/* QR Loyalty & Ordering — owner dashboard (feature-gated) */}
                        <Route path="/loyalty" element={<FeatureGate feature="qr_loyalty"><ShellOnNav><LoyaltySettings /></ShellOnNav></FeatureGate>} />
                        <Route path="/loyalty/settings" element={<FeatureGate feature="qr_loyalty"><ShellOnNav><LoyaltySettings /></ShellOnNav></FeatureGate>} />
                        <Route path="/loyalty/rewards" element={<FeatureGate feature="qr_loyalty"><ShellOnNav><LoyaltyRewards /></ShellOnNav></FeatureGate>} />
                        <Route path="/loyalty/featured-items" element={<FeatureGate feature="qr_loyalty"><ShellOnNav><LoyaltyFeatured /></ShellOnNav></FeatureGate>} />
                        <Route path="/loyalty/analytics" element={<FeatureGate feature="qr_loyalty"><ShellOnNav><LoyaltyAnalytics /></ShellOnNav></FeatureGate>} />

                        {/* Birthday Mode — one-tap celebration push. */}
                        <Route path="/apps/birthday" element={<FeatureGate feature="birthday_mode"><BirthdayMode /></FeatureGate>} />

                        {/* Happy Hour — instant promo banner with countdown. */}
                        <Route path="/apps/happy-hour" element={<FeatureGate feature="happy_hour"><HappyHour /></FeatureGate>} />

                        {/* عروضي — the café's own designs, rotated on top of whatever plays.
                            Rollout gate (venue_overlay_promos), not a FeatureGate upsell —
                            same "hide entirely, no route at all" shape as interactive_action
                            below, not "show locked with a FeatureLocked CTA": a company whose
                            player fleet hasn't been updated yet should never see this page
                            exists, not be invited to upgrade for it. Backend refuses the same
                            routes with 402 (routes/api.php's check.feature:venue_overlay_promos)
                            so a direct URL hit is refused too, not just hidden here. */}
                        {
                            features?.venue_overlay_promos &&
                            <Route path="/apps/promos" element={<Promos />} />
                        }
                        {/* The editor is its own screen on its own URL (reload keeps you there,
                            browser back returns to the list). Same rollout gate as the list. */}
                        {
                            features?.venue_overlay_promos &&
                            <Route path="/apps/promos/new" element={<Promos />} />
                        }
                        {
                            features?.venue_overlay_promos &&
                            <Route path="/apps/promos/:id" element={<Promos />} />
                        }

                        {/* Spin & Win — viral QR prize wheel + live TV celebration. */}
                        <Route path="/apps/spin-win" element={<FeatureGate feature="spin_and_win"><SpinWin /></FeatureGate>} />
                        {/* Cashier QR deep link — auto-opens the redeem confirmation. */}
                        <Route path="/apps/spin-win/redeem/:prizeCode" element={<SpinWin />} />

                        {/* Video Wall — multi-player synchronized video wall. */}
                        <Route path="/apps/video-wall"         element={<EntitlementGuard feature="video_wall"><VideoWallDashboard /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/menu-builder" element={<EntitlementGuard feature="video_wall"><VideoWallMenuBuilder /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/walls"   element={<EntitlementGuard feature="video_wall"><VideoWallIndex /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/create"  element={<EntitlementGuard feature="video_wall"><VideoWallCreate /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/library"     element={<EntitlementGuard feature="video_wall"><VideoWallLibrary /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/library/:playlistId" element={<EntitlementGuard feature="video_wall"><VideoWallLibraryEditor /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/groups"      element={<EntitlementGuard feature="video_wall"><VideoWallGroups /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/groups/:id"  element={<EntitlementGuard feature="video_wall"><VideoWallGroupShow /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/locations"   element={<EntitlementGuard feature="locations"><VideoWallLocations /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/schedule"    element={<EntitlementGuard feature="video_wall"><VideoWallSchedule /></EntitlementGuard>} />
                        <Route path="/schedule/themes"             element={<NavV6Gate open={themesOpen}><ScheduleThemesRoute /></NavV6Gate>} />
                        <Route path="/schedule/locations"          element={<EntitlementGuard feature="locations"><CafeLocations /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/menus"       element={<EntitlementGuard feature="video_wall"><VideoWallMenus /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/menus/:menuId" element={<VideoWallMenuEditor />} />
                        <Route path="/apps/video-wall/templates"   element={<EntitlementGuard feature="video_wall"><VideoWallTemplates /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/templates/:templateId" element={<EntitlementGuard feature="video_wall"><VideoWallTemplateEditor /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/simulator"   element={<EntitlementGuard feature="video_wall"><VideoWallSimulator /></EntitlementGuard>} />
                        <Route path="/apps/video-wall/promos"      element={<VideoWallPromos />} />
                        <Route path="/apps/video-wall/:id"         element={<EntitlementGuard feature="video_wall"><VideoWallShow /></EntitlementGuard>} />

                        {/* Alias for the renamed "Screens" item (formerly Devices). */}
                        <Route path="/screens"          element={<Index />} />
                        <Route path="/screens/:id/show" element={<DeviceShow />} />

                        {/* Remote Control — hero page */}
                        <Route path="/remote-control"     element={<EntitlementGuard feature="remote_control"><ShellOnNav><RemoteControl /></ShellOnNav></EntitlementGuard>} />

                        {/* Café Wizard — "+ Create" template picker (café accounts;
                            restaurant is redirected to Video Wall by the page guard). */}
                        <Route path="/create"             element={<CafeCreate />} />

                        {/* Show Page — DEV ONLY. No dev-only gate mechanism existed in this
                            app before this route; REACT_APP_APP_ENV is the smallest one
                            consistent with existing precedent (build-dev.js / build-prod.js
                            already isolate dev vs prod bundles on this exact variable —
                            'Staging' in dev's .env, 'Production' in .env.production). Lift
                            this gate deliberately when the page is ready beyond dev. */}
                        {process.env.REACT_APP_APP_ENV !== 'Production' &&
                            <Route path="/shows/:id" element={<ShowPage />} />
                        }
                    </Route>
                </Route>
                <Route path="/weather" element={<Weather />} />
                <Route path="/CornerWeather" element={<CornerWeather />} />

                <Route path="/clock" element={<Clock />} />
                <Route path="/cornerClock" element={<CornerClock />} />

                <Route path="/IframePlayer" element={<IframePlayer />} />

                {/* QR Loyalty — public guest check-in page, served on this SPA's own host
                    (app.popuppush.com/v/:venueCode). The popuppush.com apex is the
                    marketing site; see pages/Loyalty/publicUrl.js. */}
                <Route path="/v/:venueCode" element={<ScanStay />} />
                {/* QR Loyalty — the customer card. The signed token IS the
                    capability: bookmarkable, cross-device, no login. View-only. */}
                <Route path="/c/:token" element={<CustomerCard />} />

                {/* QR Loyalty — standalone kitchen display, PIN-gated (/kitchen/:venueCode) */}
                <Route path="/kitchen/:venueCode" element={<KitchenDisplay />} />
                {/* QR Loyalty — standalone cashier page, PIN-gated (/cashier/:venueCode) */}
                <Route path="/cashier/:venueCode" element={<CashierDisplay />} />


                <Route element={<ProtectedRouterTwo />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/signup/:invitation_id" element={<EmployeeSignUp />} />

                    <Route path="/forget/password" element={<ForgetPassword />} />
                    <Route path="/reset/password/:token" element={<ResetPassword />} />
                    <Route path="/verify/email/:payload" element={<VerifyEmailProcess />} />
                </Route>
                <Route path="/verify/email" element={<VerifyEmail />} />
                <Route path="/logout/process" element={<LogoutProcess />} />
                <Route element={<NotFoundGate />}>
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </BrowserRouter >)
}

export default RoutesContainer